import React, { useCallback, useState } from 'react';
import { Typography, Card, Button, Icon } from '@sravni/react-design-system';
import { File } from '@sravni/react-icons';
import { Container } from '../../landing.common';
import { useEsiaUnsignedDocs } from '../../../store/reducers/esia';
import styles from './styles.module.scss';
import { mpl } from 'helpers/client';

const { Heading, Link, Text } = Typography;

/** Баннер при наличии неподписанных согласий */
export const UnsignedBanner: React.FC = () => {
    const [inProcess, setInProcess] = useState(false);
    const documents = useEsiaUnsignedDocs();
    const edoRulesLink = 'https://f.sravni.ru/cms/file/mpl/rules_of_electronic_document_management_02.2024.pdf';

    const onClickSign = useCallback(() => {
        setInProcess(true);
        mpl.signConsentDocuments({
            signType: 'action',
            docs: documents.map(({ type, version, consentId }) => ({ type, version, id: consentId })),
        })
            .then(() => {
                location.reload();
            })
            .catch(() => {
                setInProcess(false);
            });
    }, [documents]);

    return (
        <Container className={styles.root}>
            <Heading level={2}>Чтобы увидеть персональные предложения, подпишите согласия</Heading>
            <Card className={styles.card}>
                <div className={styles.card_content}>
                    <Text size={16}>
                        Покажем индивидуальные предложения от банков. Чтобы их увидеть, вам нужно подтвердить ваше
                        согласие
                    </Text>
                    <div>
                        <Button
                            className={styles.signButton}
                            variant="primary"
                            onClick={onClickSign}
                            loading={inProcess}>
                            Подписать
                        </Button>
                    </div>
                    <div />
                </div>
                <div className={styles.documentList}>
                    {documents.map((doc) => (
                        <Link key={doc.type} className={styles.document} color="dark" href={doc.url} target="_blank">
                            <div>{doc.title}</div>
                            <Icon icon={<File />} color="blue" />
                        </Link>
                    ))}
                </div>
            </Card>
            <Text className={styles.footerText} size={14}>
                Нажимая кнопку &quot;Подписать&quot;, вы подписываете указанные выше согласия электронной подписью (в
                соответствии с правилами использования простой электронной подписи и{' '}
                <Link href={edoRulesLink} target="_blank">
                    Правилами ЭДО
                </Link>{' '}
                оператора финансовой платформы). Вы подтверждаете, что ознакомились с вышеуказанными согласиями, их
                содержание вам понятно и принято полностью
            </Text>
        </Container>
    );
};
